import React, { forwardRef } from 'react'
import cn from 'classnames'
import styles from './button.module.css'

const Button = forwardRef(
  (
    {
      children,
      onClick,
      disabled,
      noInteraction,
      className,
      style = {},
      ...props
    },
    ref
  ) => {
    return (
      <button
        className={cn(className || styles.button, {
          [styles.disabled]: disabled,
        })}
        style={{
          pointerEvents: noInteraction || disabled ? 'none' : 'auto',
          ...style,
        }}
        onClick={onClick}
        disabled={disabled || noInteraction}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    )
  }
)

export default Button
